import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

/* ===================== THUNKS ===================== */

// Party Ledger
export const fetchLedgerData = createAsyncThunk(
  "salesLedger/fetchLedgerData",
  async ({ firmId, partyId, fmdt, todt, cat }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getSalesLedgerData&firmId=${firmId}&partyId=${partyId}&fmdt=${fmdt}&todt=${todt}&cat=${cat}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
//party ledger settlement wise
export const fetchSettlementLedgerData = createAsyncThunk(
  "salesLedger/fetchSettlementLedgerData",
  async ({ firmId, partyId, fmdt, todt, cat }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getSettlementSalesLedgerData&firmId=${firmId}&partyId=${partyId}&fmdt=${fmdt}&todt=${todt}&cat=${cat}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
//party  wise outstanding data
export const fetchOutstandingData = createAsyncThunk(
  "salesLedger/fetchOutstandingData",
  async ({ firmId, partyId, fmdt, todt }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getOutsandingData&firmId=${firmId}&partyId=${partyId}&fmdt=${fmdt}&todt=${todt}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
//firm wise outstanding amt
export const fetchfirmOutstandingData = createAsyncThunk(
  "salesLedger/fetchfirmOutstandingData",
  async ({ firmId, partyId, fmdt, todt }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getfirmOutsandingData&firmId=${firmId}&partyId=${partyId}&fmdt=${fmdt}&todt=${todt}`
      );
     // console.log("irmdata=>",res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Party Opening Balance
export const fetchLedgerOpeningBal = createAsyncThunk(
  "salesLedger/fetchLedgerOpeningBal",
  async ({ firmId, partyId, fmdt, todt, cat }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getSalesLedgerOpeningBal&firmId=${firmId}&partyId=${partyId}&fmdt=${fmdt}&todt=${todt}&cat=${cat}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Firm Ledger
export const fetchFirmLedgerData = createAsyncThunk(
  "salesLedger/fetchFirmLedgerData",
  async ({ firmId, fmdt, todt, cat }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getFirmLedgerData&firmId=${firmId}&fmdt=${fmdt}&todt=${todt}&cat=${cat}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Firm Opening Balance
export const fetchLedgerOpeningBal1 = createAsyncThunk(
  "salesLedger/fetchLedgerOpeningBal1",
  async ({ firmId, fmdt, todt, cat }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getSalesOpeningBal1&firmId=${firmId}&fmdt=${fmdt}&todt=${todt}&cat=${cat}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/* ===================== SLICE ===================== */

const salesLedgerSlice = createSlice({
  name: "salesLedger",
  initialState: {
    data: [],
    settlementdata:[],
    outstandingdata:[],
    firmoutstandingdata:[],
    openingBal: [],
    firmData: [],
    openingBal1: [],

    ledgerLoading: false,
    openingLoading: false,
    firmLedgerLoading: false,
    openingLoading1: false,

    error: null,
  },

  reducers: {
    clearLedgerData: (state) => {
      state.data = [];
      state.openingBal = [];
      state.firmData = [];
      state.openingBal1 = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      /* ===== PARTY LEDGER ===== */
      .addCase(fetchLedgerData.pending, (state) => {
        state.ledgerLoading = true;
        state.error = null;
      })
      .addCase(fetchLedgerData.fulfilled, (state, action) => {
        state.ledgerLoading = false;
        state.data = action.payload?.data || [];
      })
      .addCase(fetchLedgerData.rejected, (state, action) => {
        state.ledgerLoading = false;
        state.error = action.payload;
      })

        /* ===== PARTY Settlement LEDGER ===== */
      .addCase(fetchSettlementLedgerData.pending, (state) => {
        state.ledgerLoading = true;
        state.error = null;
      })
      .addCase(fetchSettlementLedgerData.fulfilled, (state, action) => {
        state.ledgerLoading = false;
        state.settlementdata = action.payload?.data || [];
      })
      .addCase(fetchSettlementLedgerData.rejected, (state, action) => {
        state.ledgerLoading = false;
        state.error = action.payload;
      })
         /* ===== PARTY Outstanding data ===== */
      .addCase(fetchOutstandingData.pending, (state) => {
        state.ledgerLoading = true;
        state.error = null;
      })
      .addCase(fetchOutstandingData.fulfilled, (state, action) => {
        state.ledgerLoading = false;
        state.outstandingdata = action.payload?.data || [];
      })
      .addCase(fetchOutstandingData.rejected, (state, action) => {
        state.ledgerLoading = false;
        state.error = action.payload;
      })
    /* ===== firm Outstanding data ===== */
      .addCase(fetchfirmOutstandingData.pending, (state) => {
        state.ledgerLoading = true;
        state.error = null;
      })
      .addCase(fetchfirmOutstandingData.fulfilled, (state, action) => {
        state.ledgerLoading = false;
        state.firmoutstandingdata = action.payload?.data || [];
      })
      .addCase(fetchfirmOutstandingData.rejected, (state, action) => {
        state.ledgerLoading = false;
        state.error = action.payload;
      })


      /* ===== PARTY OPENING ===== */
      .addCase(fetchLedgerOpeningBal.pending, (state) => {
        state.openingLoading = true;
        state.error = null;
      })
      .addCase(fetchLedgerOpeningBal.fulfilled, (state, action) => {
        state.openingLoading = false;
        state.openingBal = action.payload?.data || [];
      })
      .addCase(fetchLedgerOpeningBal.rejected, (state, action) => {
        state.openingLoading = false;
        state.error = action.payload;
      })

      /* ===== FIRM LEDGER ===== */
      .addCase(fetchFirmLedgerData.pending, (state) => {
        state.firmLedgerLoading = true;
        state.error = null;
      })
      .addCase(fetchFirmLedgerData.fulfilled, (state, action) => {
        state.firmLedgerLoading = false;
        state.firmData = action.payload?.data || [];
      })
      .addCase(fetchFirmLedgerData.rejected, (state, action) => {
        state.firmLedgerLoading = false;
        state.error = action.payload;
      })

      /* ===== FIRM OPENING ===== */
      .addCase(fetchLedgerOpeningBal1.pending, (state) => {
        state.openingLoading1 = true;
        state.error = null;
      })
      .addCase(fetchLedgerOpeningBal1.fulfilled, (state, action) => {
        state.openingLoading1 = false;
        state.openingBal1 = action.payload?.data || [];
      })
      .addCase(fetchLedgerOpeningBal1.rejected, (state, action) => {
        state.openingLoading1 = false;
        state.error = action.payload;
      });
  },
});

/* ===================== SELECTORS ===================== */

export const { clearLedgerData } = salesLedgerSlice.actions;

export const selectSalesLedgerData = (state) => state.salesLedger.data;
export const selectSettlementSalesLedgerData = (state) => state.salesLedger.settlementdata;
export const selectoutstandingData = (state) => state.salesLedger.outstandingdata;
export const selectfirmoutstandingData = (state) => state.salesLedger.firmoutstandingdata;

export const selectSalesLedgerOpeningBal = (state) => state.salesLedger.openingBal;

export const selectFirmSalesLedgerData = (state) => state.salesLedger.firmData;
export const selectFirmSalesOpeningData = (state) => state.salesLedger.openingBal1;

export const selectLedgerLoading = (state) => state.salesLedger.ledgerLoading;
export const selectOpeningLoading = (state) => state.salesLedger.openingLoading;
export const selectFirmLedgerLoading = (state) => state.salesLedger.firmLedgerLoading;
export const selectFirmOpeningLoading = (state) => state.salesLedger.openingLoading1;

export const selectSalesLedgerError = (state) => state.salesLedger.error;

export default salesLedgerSlice.reducer;
